module.exports = __webpack_public_path__ + "img/speedtest.712c950f.svg";